import React from 'react';
import { toast } from 'react-toastify';

const warningIcon = (
   <svg viewBox='0 0 24 24' width='100%' height='100%' fill='currentColor'>
      <path d='M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z' />
   </svg>
);

const errorIcon = (
   <svg viewBox='0 0 24 24' width='100%' height='100%' fill='currentColor'>
      <path d='M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z' />
   </svg>
);

const infoIcon = (
   <svg viewBox='0 0 24 24' width='100%' height='100%' fill='currentColor'>
      <path d='M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z' />
   </svg>
);

const successIcon = (
   <svg viewBox='0 0 24 24' width='100%' height='100%' fill='currentColor'>
      <path d='M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z' />
   </svg>
);

const showToast = (type, message, icon, toastOptions = {}) => {
   return toast[type](message, {
      toastId: message,
      icon: icon,
      ...toastOptions,
   });
};

export const toastWarn = (message, toastOptions = {}) => {
   return showToast('warn', message, warningIcon, toastOptions);
};

export const toastError = (message, toastOptions = {}) => {
   return showToast('error', message, errorIcon, toastOptions);
};

export const toastInfo = (message, toastOptions = {}) => {
   return showToast('info', message, infoIcon, toastOptions);
};

export const toastSuccess = (message, toastOptions = {}) => {
   return showToast('success', message, successIcon, toastOptions);
};
